<div *ngIf="message" class="flex gap-3 w-full p-4 mobile:p-0">
  <div *ngIf="message.type !== 'USER'" class="w-full flex gap-3">
    <ig-image class="mobile:hidden" [src]="travelBuddySettings.ui.avatar.thumbnail"
      cls="!w-10 !h-10 min-w-[40px] min-h-[40px] rounded-full"></ig-image>
    <div class="flex flex-col gap-2 w-[calc(100%-52px)] mobile:w-full">
      <div class="flex flex-col gap-1 group">
        <div class="flex gap-3 items-center">
          <ig-image class="hidden mobile:block" [src]="travelBuddySettings.ui.avatar.thumbnail"
            cls="!w-6 !h-6 min-w-[24px] min-h-[24px] rounded-full"></ig-image>
            <div class="ig-ai-typing text-xs text-gray-500 font-medium">
            {{ message.name }} {{ message.type === 'AI_THINKING' ? 'is typing...' : '' }}
          </div>
        </div>
        <div class="flex gap-2 relative">
          <div
            class="ig-im-answer w-full py-3 px-4 bg-white text-sm text-gray-700 rounded-2xl rounded-tl-none border border-gray-200 shadow-sm transition-all overflow-visible mobile:border-none mobile:shadow-none mobile:p-1"
            [class.!w-[50%]]="isScreenExpanded && hasAdding" [class.!max-w-[800px]]="isScreenExpanded"
            [class.max-h-[60vh]]="isScreenExpanded" [class.!overflow-y-auto]="isScreenExpanded">
            <ig-loading-dot *ngIf="message.type === 'AI_THINKING'" [loadingTips]="loadingTips">
            </ig-loading-dot>

            <div *ngIf="message.type === 'AI' || message.type === 'AI_STREAM'" class="overflow-x-hidden">
              <div [innerHTML]="message.msg" class="leading-relaxed max-w-none ig-im-answer-chat"
                style="word-wrap: break-word; overflow-wrap: break-word"></div>

              <div #addingContent class="overflow-hidden" [class.ig-im-adding-expanded]="isScreenExpanded"
                [class.!w-0]="!hasAdding" [class.!h-0]="!hasAdding">
                <ng-content select="[adding]"></ng-content>
              </div>

              <!-- Action Buttons -->
              <!-- <div class="flex items-center justify-between mt-3 pt-3 border-t border-gray-200">
                <div class="flex items-center gap-1 feedback-buttons" *ngIf="message.type === 'AI' || message.type === 'AI_STREAM'">
                  <button (click)="giveFeedback('good')"
                          [class]="'feedback-btn good-feedback ' + (message.feedback === 'good' ? 'active' : '')"
                          class="flex items-center gap-1 text-sm px-2 py-1 rounded-md transition-all duration-200 background-none text-gray-400 hover:text-green-600 hover:bg-green-50">
                    <mat-icon class="text-sm">thumb_up</mat-icon>
                    <span class="text-xs">Good</span>
                  </button>

                  <button (click)="giveFeedback('bad')"
                          [class]="'feedback-btn bad-feedback ' + (message.feedback === 'bad' ? 'active' : '')"
                          class="flex items-center gap-1 text-sm px-2 py-1 rounded-md transition-all duration-200 background-none text-gray-400 hover:text-red-600 hover:bg-red-50">
                    <mat-icon class="text-sm">thumb_down</mat-icon>
                    <span class="text-xs">Bad</span>
                  </button>
                </div>

                <div class="flex items-center gap-2">
                  <button (click)="copyResponse()"
                          class="flex items-center gap-1 text-sm text-gray-400 hover:text-gray-600 transition-colors background-none">
                    <mat-icon class="text-sm">content_copy</mat-icon>
                    <span>Copy</span>
                  </button>

                  <button (click)="shareResponse()"
                          class="flex items-center gap-1 text-sm text-gray-400 hover:text-gray-600 transition-colors background-none">
                    <mat-icon class="text-sm">share</mat-icon>
                    <span>Share</span>
                  </button>
                </div>
              </div> -->

              <!-- Questions moved to the message input bar as suggested prompts -->
              <!-- <div *ngIf="message?.questions?.length" class="mt-3">
                <div class="text-xs">
                  <div *ngFor="let q of message?.questions">
                    <div (click)="askQ(cleanQuestion(q))"
                         class="text-gray-600 rounded-lg py-2 px-3 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors">
                      <div class="font-medium w-[85%]">{{ cleanQuestion(q) }}</div>
                      <mat-icon class="leading-6 text-right text-gray-400">chevron_right</mat-icon>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <div *ngIf="message.type === 'AI_ERROR'" class="overflow-x-hidden">
              <mat-icon class="text-red-500 relative top-[1px] !w-[21px] !h-[15px] !leading-4 text-base">error
              </mat-icon>
              <span [innerText]="errorMsg"></span>
              <span>Please <a (click)="tryAskAgain()">try again</a> later.</span>
            </div>
          </div>

          <div *ngIf="getAvailableMatchedPlaces(message?.placesMatched)?.length"
            class="absolute -top-7 right-0 items-center gap-2 border border-gray-200 rounded-md px-2 bg-white flex">
            <div *ngIf="isAllowClick; else saveTripLoginPrompt" aria-role="button" aria-label="Save this trip"
              class="flex items-center gap-0 text-sm text-gray-600 hover:text-gray-600 transition-colors background-none cursor-pointer"
              #saveTripMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="saveTripMenu" (menuOpened)="tripTitle = ''">
              <mat-icon class="text-sm w-5 leading-6 text-gray-600">bookmark</mat-icon>
              <span>Save this trip</span>
            </div>
            <ng-template #saveTripLoginPrompt>
              <div aria-role="button" aria-label="Save this trip"
                class="flex items-center gap-0 text-sm text-gray-600 hover:text-gray-600 transition-colors background-none cursor-pointer"
                (click)="onSaveTripMenuClick($event)">
                <mat-icon class="text-sm w-5 leading-6 text-gray-600">bookmark</mat-icon>
                <span>Save this trip</span>
              </div>
            </ng-template>

            <mat-menu #saveTripMenu="matMenu" class="save-trip-menu !max-w-[400px] !w-[400px]">
              <div *ngIf="canSaveMoreTrips" (click)="$event.stopPropagation()" class="px-4 py-3 flex flex-col gap-0">
                <h3 class="font-medium text-gray-700 m-0">Save this trip</h3>
                <mat-form-field appearance="outline" class="w-full text-sm mt-3">
                  <mat-label>Trip Title</mat-label>
                  <input matInput [(ngModel)]="tripTitle"
                    [placeholder]="'e.g. Summer Vacation in ' + travelBuddySettings.cityName"
                    (keydown.enter)="onSaveTrip()" />
                </mat-form-field>
                <div class="flex justify-end">
                  <ig-button mat-raised-button [isAsync]="true" (trigger)="onSaveTrip($event)"
                    [disabled]="!tripTitle.trim()">
                    Save
                  </ig-button>
                </div>
              </div>

              <div *ngIf="!canSaveMoreTrips">
                <div class="px-4 py-3 flex flex-col items-end gap-2">
                  <p class=" text-gray-700 m-0">You have reached the maximum number of saved trips</p>
                  <button mat-button (click)="saveTripMenuTrigger?.closeMenu()" class="w-[80px]">OK</button>
                </div>
              </div>
            </mat-menu>

            <!-- <button (click)="shareResponse()"
                          class="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-600 transition-colors background-none">
                    <mat-icon class="text-sm">share</mat-icon>
                    <span>Share</span>
                  </button> -->
          </div>

          <!-- <div #addingContentExpanded class="ig-im-expanded-area" [class.w-[50%]]="isScreenExpanded"
            [class.h-[60vh]]="isScreenExpanded && hasAddingContent()">
          </div> -->
        </div>
      </div>
      <!-- <div *ngIf="message?.questions?.length" class="text-xs">
        <div class="mb-1">Questions you might want to ask</div>
        <div *ngFor="let q of message?.questions">
          <div (click)="askQ(q)"
            class="border-2 border-[lightgray] text-gray-600 rounded-3xl px-4 py-1 flex items-center justify-between cursor-pointer max-w-[490px] mb-1">
            <div class=" font-extralight w-[85%]">{{q}}</div>
            <mat-icon class="text-[24px] leading-6">trending_flat</mat-icon>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <div *ngIf="message.type === 'USER'" class="w-full flex justify-end gap-3 relative border-solid border-gray-200 mobile:border-t mobile:border-b">
    <div class="flex flex-col gap-1 text-gray-600 w-full items-end mobile:pt-3">
      <div class="flex items-center gap-2 text-xs font-medium text-right text-gray-500 mobile:pr-9">
        <span>{{ message.name }}</span>
        <span *ngIf="message.timestamp" class="text-gray-400">{{
          getTimeAgo(message.timestamp)
          }}</span>
      </div>
      <div class="relative group max-w-[500px]" [class.!max-w-[700px]]="isScreenExpanded">
        <div class="px-4 py-3 bg-white text-gray-600 text-sm rounded-2xl rounded-tr-none" [innerHTML]="message.msg">
        </div>
        <!-- <div *ngIf="message.isEditable"
             class="absolute -left-16 top-1/2 -translate-y-1/2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity mobile:opacity-100 mobile:-left-14">
          <button (click)="editMessage()"
                  class="flex items-center justify-center w-6 h-6 bg-gray-200 hover:bg-gray-300 rounded-full transition-colors mobile:w-5 mobile:h-5"
                  title="Edit message">
            <mat-icon class="text-gray-600 !text-sm !w-4 !h-4 !leading-4 mobile:!text-xs mobile:!w-3 mobile:!h-3">edit</mat-icon>
          </button>
          <button (click)="deleteMessage()"
                  class="flex items-center justify-center w-6 h-6 bg-red-100 hover:bg-red-200 rounded-full transition-colors mobile:w-5 mobile:h-5"
                  title="Delete message">
            <mat-icon class="text-red-600 !text-sm !w-4 !h-4 !leading-4 mobile:!text-xs mobile:!w-3 mobile:!h-3">delete</mat-icon>
          </button>
        </div> -->
      </div>
    </div>

    @if (!letterAvatar) {
    @if (isAllowClick && avatar && avatar !== defaultAvatar) {
    <div class="relative mobile:absolute">
      <ig-image [src]="avatar || defaultAvatar"
        cls="!w-10 !h-10 min-w-10 min-h-10 rounded-full aspect-square mobile:!w-6 mobile:!h-6 mobile:min-w-6 mobile:min-h-6 mobile:translate-y-1.5"></ig-image>
      <div class="absolute top-0 right-0 w-10 h-10 z-10 bg-transparent cursor-pointer" [matMenuTriggerFor]="actionMenu">
      </div>
    </div>
    } @else {
    <ig-image class="mobile:absolute" [src]="avatar || defaultAvatar" cls="!w-10 !h-10 min-w-10 min-h-10 rounded-full aspect-square mobile:!w-6 mobile:!h-6 mobile:min-w-6 mobile:min-h-6 mobile:translate-y-1.5"></ig-image>
    }
    } @else {
    <div
      class="w-10 h-10 min-w-10 min-h-10 aspect-square rounded-full bg-blue-200 text-sm font-semibold flex justify-center items-center text-blue-500 uppercase cursor-pointer"
      [matMenuTriggerFor]="actionMenu">
      <span>{{ letterAvatar.split('')[0] }}</span>
    </div>
    }

    <mat-menu #actionMenu="matMenu" *ngIf="isAllowClick && ((avatar && avatar !== defaultAvatar) || letterAvatar)">
      <button mat-menu-item (click)="avatarClicked.emit()">Logout</button>
    </mat-menu>
  </div>
</div>
